'use client';

import { c as _c } from "react/compiler-runtime";
import { Sun, Snowflake } from 'lucide-react';
import React from 'react';
import { useTranslations } from 'next-intl';
interface SeasonSwitcherProps {
  season?: 'summer' | 'winter' | null;
  setSeason?: (season: 'summer' | 'winter') => void;
  // onDark: sits on the dark nav bar (default). onLight: sits on the white mobile menu card.
  variant?: 'onDark' | 'onLight';
}
export const SeasonSwitcher = t0 => {
  const $ = _c(30);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    season: externalSeason,
    setSeason: externalSetSeason,
    variant: t2
  } = t1;
  const variant = t2 === undefined ? "onDark" : t2;
  const getDefaultSeason = _temp;
  const [internalSeason, setInternalSeason] = React.useState(getDefaultSeason);
  const t = useTranslations("Header");
  const season = externalSeason !== undefined ? externalSeason : internalSeason;
  const setSeason = externalSetSeason || setInternalSeason;
  let t3;
  if ($[2] !== variant) {
    t3 = variant === "onLight" ? {
      container: "bg-primary/10",
      active: "bg-gradient-to-r from-nav-gradient-from to-nav-gradient-to text-white shadow-md font-bold",
      inactive: "text-foreground/70 hover:text-foreground hover:bg-primary/10"
    } : {
      container: "",
      active: "bg-white text-primary shadow-sm font-bold",
      inactive: "text-white ring-2 ring-inset ring-white/60 hover:bg-white/15"
    };
    $[2] = variant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const styles = t3;
  const t4 = `flex items-center gap-1 rounded-lg p-1 ${styles.container}`;
  let t5;
  if ($[4] !== setSeason) {
    t5 = () => setSeason("summer");
    $[4] = setSeason;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `flex items-center gap-1.5 px-2.5 py-2 text-sm rounded-md transition-all xl:gap-2 xl:px-3 ${season === "summer" ? styles.active : styles.inactive}`;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Sun className="w-4 h-4" />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t) {
    t8 = t("summer");
    $[7] = t;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <span className="hidden sm:inline">{t8}</span>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== t9) {
    t10 = <button onClick={t5} className={t6} aria-label="Switch to summer">{t7}{t9}</button>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== setSeason) {
    t11 = () => setSeason("winter");
    $[15] = setSeason;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `flex items-center gap-1.5 px-2.5 py-2 text-sm rounded-md transition-all xl:gap-2 xl:px-3 ${season === "winter" ? styles.active : styles.inactive}`;
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Snowflake className="w-4 h-4" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t) {
    t14 = t("winter");
    $[18] = t;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = <span className="hidden sm:inline">{t14}</span>;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t15) {
    t16 = <button onClick={t11} className={t12} aria-label="Switch to winter">{t13}{t15}</button>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t16 || $[28] !== t4) {
    t17 = <div className={t4}>{t10}{t16}</div>;
    $[26] = t10;
    $[27] = t16;
    $[28] = t4;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};

// Note: When season is null (homepage), neither button will have the active state
function _temp() {
  const now = new Date();
  const month = now.getMonth();
  return month >= 10 || month <= 3 ? "winter" : "summer";
}